import { render, staticRenderFns } from "./RecuperarSenha.vue?vue&type=template&id=e051a112"
import script from "./RecuperarSenha.vue?vue&type=script&lang=js"
export * from "./RecuperarSenha.vue?vue&type=script&lang=js"
import style0 from "./RecuperarSenha.vue?vue&type=style&index=0&id=e051a112&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports